import React from "react";
import { ModalProps } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const CancelModelSurvey: React.FC<ModalProps> = ({
  workOrderId,
  area,
  errorCode,
  contractor,
  props,
}) => {
  const { t } = useTranslation();

  const navigateToCancelSurvey = () => {
    props?.history.push("/CancelRepair");
  };

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a
        id="exitmodal-btn1"
        data-testid="Cancel-button"
        className="text-base no-underline text-black"
        onClick={navigateToCancelSurvey}
        onKeyDown={navigateToCancelSurvey}
      >
        <div className="py-2 cursor-pointer text-black text-base no-underline dropdown-item pl-0">
          {t("Survey.CP077_CancelSurvey")}
        </div>
      </a>
    </>
  );
};

export default CancelModelSurvey;
 